
import { Component, Vue } from "vue-property-decorator";
import { TextBlockType } from "../../core/constants";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import store from "../../core/store";

@Component
export default class Team extends Vue {
  data: any[] = [];
  windowWidth: number = window.innerWidth;


  private get isMobile() {
    return this.windowWidth < 768;
  }

  async mounted() {
    let filter: any = {};
    filter["TextBlockType"] = {
      type: "equals",
      filter: TextBlockType.Teams,
      filterType: "enum",
    };
    const gridStatus = JSON.stringify({ filters: filter });

    const url = `${
      Settings.HostName
    }/api/cztextblocks/list?startRow=0&endRow=14&lookup=true&gridstatus=${encodeURIComponent(
      gridStatus
    )}`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting professionals");
      return;
    }
    this.data = data.rowData;
    this.checkScroll();
    window.addEventListener("resize", this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.windowWidth = window.innerWidth;
  }

  getImagePath(img: string) {
    if (img === undefined || img === null || img === "") {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }

  checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs.teamBannerContainer as HTMLElement | null;
      const list = this.$refs.teamBannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll ? "flex-start" : "center";
      }
    });
  }
}
